import featureToggles from 'shared/featureToggles'

import { ReservationsView } from '../../dashboard-transactions'
import { SubscriptionsView } from '../../dashboard-subscriptions'
import { CreditCardView } from '../../dashboard-credit-cards'
import { VehiclesView } from '../../dashboard-vehicles'
import { AccountView, DeleteAccountView } from '../../dashboard-account'
import { PromotionsView } from '../../dashboard-promotions'

import { promotionsSelector } from '../selectors'

import DashboardView from './DashboardView'
import './DashboardContainerView.scss'

import DashboardRoute from './DashboardRoute'
import { isArrayValid } from './utils'

const DashboardContainerView = ({ promotions }) => (
    <>
        <DashboardRoute exact path="/dashboard" component={DashboardView} />
        <DashboardRoute path="/dashboard/transactions" component={ReservationsView} />
        {featureToggles.newSubscriptionDashboard && (
            <DashboardRoute path="/dashboard/subscriptions/:list?" component={SubscriptionsView} />
        )}
        <DashboardRoute path="/dashboard/credit-cards" component={CreditCardView} />
        <DashboardRoute path="/dashboard/vehicles" component={VehiclesView} />
        {isArrayValid(promotions) ? <DashboardRoute path="/dashboard/promotions" component={PromotionsView} /> : null}
        <DashboardRoute
            path="/dashboard/account/delete"
            component={DeleteAccountView}
            hasMenu={false}
            hasGreeting={false}
        />
        <DashboardRoute exact path="/dashboard/account/" component={AccountView} />
    </>
)

const mapStateToProps = createStructuredSelector({
    promotions: promotionsSelector,
})

export default connect(mapStateToProps)(DashboardContainerView)
